import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { Tabla } from "../../../../../components/Table/Table";
import HistorialActuaciones from "../HistorialActuaciones";
import "./index.css";
import moment from "moment";

const DetallesModal = ({ show, handleClose, data }) => {
  const [modalShow, setModalShow] = useState(false);
  const [actuaciones, setActuaciones] = useState([]);

  const handleShowModal = (e) => {
    setActuaciones(e);
    setModalShow(true);
  };
  const handleCloseModal = () => {
    setActuaciones([]);
    setModalShow(false);
  };

  const columns = [
    {
      title: "CONTRIBUYENTE",
      dataIndex: "APYNOM",
    },
    {
      title: "IMPONIBLE",
      dataIndex: "IMPONIBLE",
    },
    {
      title: "CATEGORÍA",
      dataIndex: "categorias",
      render: () => {
        return (
          <span>
            1 con cap contr
          </span>
        );
      },
    },
    {
      title: "RECURSO",
      dataIndex: "RECURSO",
    },
    // {
    //   title: "MONTO",
    //   dataIndex: "monto",
    // },
    // {
    //   title: "FECHA LÍMITE EXT",
    //   dataIndex: "fecha_limit",
    // },
    {
      title: "HISTORIAL ACTUACIONES",
      dataIndex: "",
      render: (row) => {
        return (
          row?.historico ? (
            <div>
              <div className="mb-2">{row.historico.SITUACION}</div>
              <div>
                <Button className="btn-outline" onClick={() => handleShowModal(row)}>Ver todos</Button>
              </div>
            </div>
          ) : row?.actuaciones?.length ? (
            <div>
              <div className="mb-2">{row?.actuaciones[0].SITUACION || row?.actuaciones[0].tipo_etapa?.nombre}</div>
              <div>
                <Button className="btn-outline" onClick={() => handleShowModal(row)}>Ver todos</Button>
              </div>
            </div>
          ) : (
            <div>
              <div className="mb-2">Sin actuaciones</div>
            </div>
          )
        );
      }
    },
    {
      title: "FECHA ÚLTIMA ACTUACIÓN",
      dataIndex: "fecha_ult",
    },
  ];

  const formatData = (array) => {
    if (!array?.length) return [];

    return array.map((e) => {
      let actuacion = "";

      if (e?.actuaciones) {
        actuacion = e?.actuaciones[e?.actuaciones.length - 1];
      }
      return {
        ...e,
        fecha_ult: actuacion ? moment(actuacion.fecha).format("DD/MM/YYYY") : e?.historico ? e.historico.FECHA : "",
        APYNOM: e.CONTRIBUYENTE?.APYNOM || ""
      };
    });
  };
  return (
    <div>
      <Modal
        show={show}
        onHide={handleClose}
        animation={false}
        centered
        className="detalles-modal inbox-section"
      >
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body className="p-5">
          <div className="data-table section-table">
            <Tabla dataList={formatData(data?.imponibles)} columns={columns} pagination={false} />
          </div>
          {modalShow && <HistorialActuaciones show={modalShow} handleClose={handleCloseModal} data={actuaciones} />}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleClose}>Cerrar</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default DetallesModal;
